import script from "./cert-manager.io.certificate.vue?vue&type=script&lang=ts"
export * from "./cert-manager.io.certificate.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__